// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2DDMx","title":"AfterFrontImage_title__26N9Y"};